/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class RemoteControlServiceAdmin extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 제어 요청 */
    postControl = (deviceId, requestBody) => this.post(apiWrapper.managerApiV1(`/devices/${deviceId}/control`), requestBody);
    /** 제어 요청 목록 조회 */
    getControlRequestsList = async (deviceId, param) => {
        return await this.get(apiWrapper.managerApiV1(`/devices/${deviceId}/control-requests`), param);
    };
}
